// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"2931b27c","199":"18c4fdfb","585":"9248fdc1","802":"100d450b","925":"c3d0963f"}[chunkId] + ".chunk.css";
};